import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../appProvider/contextProvider';
import HelperComponent from '../../components/HelperComponent/HelperComponent';
import PremiumLock from '../../components/PremiumFeatures/PremiumLock';
import { activateBellPrompt, activateDesktopPrompt, activateGDPRPrompt, activateMobilePrompt, updateBranding } from '../../services/websitesService';
import {DESKTOP_DESIGN_TYPE, MOBILE_DESIGN_TYPE} from './permissionPrompts/propmtsConfig';

const PermissionPrompt = () => {

    const history = useHistory();
    
    const {selectedWebsite, setSelectedWebsite, isFeatureAvailable} = useAppContext();
    
    const [mobile_prompt, setMobilePrompt] = useState(false); 
    const [desktop_prompt, setDesktopPrompt] = useState(false); 
    const [gdpr_prompt, setGDPRPrompt] = useState(false);
    const [bell_prompt, setBellPrompt] = useState(false);

    useEffect(() => {
        setMobilePrompt(selectedWebsite?.mobile_prompt.is_enabled);
        setDesktopPrompt(selectedWebsite?.desktop_prompt.is_enabled);
        setGDPRPrompt(selectedWebsite?.gdpr_prompt.is_enabled);
        setBellPrompt(selectedWebsite?.bell_prompt.is_enabled);
    }, [selectedWebsite]);


    const activateDesktop_Prompt = useMutation( () => {
        return activateDesktopPrompt(selectedWebsite?.id, {is_enabled: !desktop_prompt});
    },{
        onSuccess: ((desktop_prompt_data) => {
            if(desktop_prompt_data.errors) {

                // handelError(webSiteData.error);
            } else {
                selectedWebsite.desktop_prompt = desktop_prompt_data;
                setSelectedWebsite(selectedWebsite);
                setDesktopPrompt(!desktop_prompt);
                toast.success(`Desktop prompt ${desktop_prompt ? 'disabled' : 'enabled'} successfully`);
            }
        }),
        onError: ((error) => {
            console.log(error);
            // toast.error(error.message);
        })
    });

    const activateMobile_Prompt = useMutation( () => {
        return activateMobilePrompt (selectedWebsite?.id,{is_enabled: !mobile_prompt});
    },{
        onSuccess: ((mobile_prompt_data) => {
            if(mobile_prompt_data.errors) {

                // handelError(webSiteData.error);
            } else {
                selectedWebsite.mobile_prompt = mobile_prompt_data;
                setSelectedWebsite(selectedWebsite);
                setMobilePrompt(!mobile_prompt);
                toast.success(`Mobile prompt ${mobile_prompt ? 'disabled' : 'enabled'} successfully`);
            }
        }),
        onError: ((error) => {
            console.log(error);
            // toast.error(error.message);
        })
    });

    const activateGDPR_Prompt = useMutation( () => {
        return activateGDPRPrompt(selectedWebsite?.id,{is_enabled: !gdpr_prompt});
    },{
        onSuccess: ((gdpr_prompt_data) => {
            if(gdpr_prompt_data.errors) {

                // handelError(webSiteData.error);
            } else {
                selectedWebsite.gdpr_prompt = gdpr_prompt_data;
                setSelectedWebsite(selectedWebsite);
                setGDPRPrompt(!gdpr_prompt);
                toast.success(`GDPR prompt ${gdpr_prompt ? 'disabled' : 'enabled'} successfully`);
            }
        }),
        onError: ((error) => {
            console.log(error);
            // toast.error(error.message);
        })
    });

    const activateBell_Prompt = useMutation( () => {
        return activateBellPrompt(selectedWebsite?.id, {is_enabled: !bell_prompt});
    },{
        onSuccess: ((bell_prompt_data) => {
            if(bell_prompt_data.errors) {

                // handelError(webSiteData.error);
            } else {
                selectedWebsite.bell_prompt = bell_prompt_data;
                setSelectedWebsite(selectedWebsite);
                setBellPrompt(!bell_prompt);
                toast.success(`Notification Bell prompt ${bell_prompt ? 'disabled' : 'enabled'} successfully`);
            }
        }),
        onError: ((error) => {
            console.log(error);
            // toast.error(error.message);
        })
    });

    const handelDesktopPromptChange = (event) => {
        event.preventDefault();
        activateDesktop_Prompt.mutate();
    }

    const handelMobilePromptChange = (event) => {
        event.preventDefault();
        activateMobile_Prompt.mutate();
    }

    const handelGDPRPromptChange = (event) => {
        event.preventDefault();
        activateGDPR_Prompt.mutate();
    }

    const handelBellPromptChange = (event) => {
        event.preventDefault();
        activateBell_Prompt.mutate();
    }

    const updateBrandingForPrompt = useMutation((event) => {
        event.preventDefault();
       return updateBranding(selectedWebsite?.id, !selectedWebsite?.is_branding_enabled); 
    }, {
        onSuccess: (website) => {
            if(website.errors && website.error) {

            } else {
                setSelectedWebsite(website);
                toast.success(`Branding 
                ${website.is_branding_enabled ? 'enabled' : 'disabled'}
                Successfully`);
            }
        }
    });

  
    return <>
        <div className="panel full-height">
                <div className="panel-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">
                            Permission Prompt
                            <HelperComponent
                                component={'Permission Prompt'}  
                                href="https://chirpyweb.com/documentation_posts/permission-prompt/" />
                        </h3>
                    </div>                                
                </div>
                <div className="panel-body d-flex flex-column scrollable_y">
                    <div className="table-responsive">
                        <table className="table table-hover permissions-table">
                            <thead className="bg-grey">
                                <tr>
                                    <th>Platform</th>
                                    <th>Name</th>
                                    <th>Subscription Type</th>
                                    <th>Active</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Desktop</td>
                                    <td>{DESKTOP_DESIGN_TYPE[selectedWebsite?.desktop_prompt?.type] || ''}</td>
                                    <td>{selectedWebsite?.desktop_prompt?.type === 'native' ? 'One-click' : 'Two-click'}</td>
                                    { !isFeatureAvailable('desktop-permission-prompt') ? <> 
                                            <td>
                                                Feature available for Premium/Enterprise user
                                            </td>
                                            <td>
                                                <PremiumLock />
                                            </td>
                                        </> : <> 
                                            <td >
                                                <label className="toggle-control toggle-control-sm ">
                                                    <input type="checkbox" checked={desktop_prompt} onChange={handelDesktopPromptChange}/>
                                                    <span className="control"></span>
                                                </label>
                                            </td>
                                            <td >
                                                <button className="btn btn-primary" onClick={() => history.push('/desktop-prompt')} >Setup</button>
                                            </td>
                                        </>}
                                </tr>
                                <tr>
                                    <td>Mobile</td>
                                    <td>{MOBILE_DESIGN_TYPE[selectedWebsite?.mobile_prompt?.type] || ''}</td>
                                    <td>{selectedWebsite?.mobile_prompt?.type === 'native' ? 'One-click' : 'Two-click'}</td>
                                    { !isFeatureAvailable('mobile-permission-prompt') ? <> 
                                            <td>
                                                Feature available for Premium/Enterprise user
                                            </td>
                                            <td>  
                                                <PremiumLock />
                                            </td>
                                        </> : <> 
                                            <td>
                                                <label className="toggle-control toggle-control-sm ">
                                                    <input type="checkbox"  checked={mobile_prompt} onChange={handelMobilePromptChange} />
                                                    <span className="control"></span>
                                                </label>
                                            </td>
                                            <td>
                                                <button className="btn btn-primary" onClick={() => history.push('/mobile-prompt')}>Setup</button>
                                            </td>
                                        </>
                                    }
                                </tr>
                                <tr>
                                    <td>GDPR</td>
                                    <td>{DESKTOP_DESIGN_TYPE[selectedWebsite?.gdpr_prompt?.type] || ''}</td>
                                    <td>{selectedWebsite?.gdpr_prompt?.type === 'native' ? 'One-click' : 'Two-click'}</td>
                                    { !isFeatureAvailable('gdpr-permission-prompt') ? <> 
                                            <td>
                                                Feature available for Premium/Enterprise user
                                            </td>
                                            <td> 
                                                <PremiumLock />
                                            </td>
                                        </> : <> 
                                            <td >
                                                <label className="toggle-control toggle-control-sm ">
                                                    <input type="checkbox" checked={gdpr_prompt} onChange={handelGDPRPromptChange} />
                                                    <span className="control"></span>
                                                </label>
                                            </td>
                                            <td >
                                                <button className="btn btn-primary" onClick={() => history.push('/gdpr-prompt')} >Setup</button>
                                            </td>
                                        </>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div> 
                    <div className="table-responsive my-3">
                        <table className="table table-hover permissions-table">
                            <colgroup>
                                <col width="45%"/>
                                {/* <col width="40%"/> */}
                                <col width="10%"/>
                                <col width="12%"/>
                            </colgroup>
                            <thead className="bg-grey">                                        
                                <tr>
                                    <th>Notifications Bell</th>
                                    {/* <th></th> */}
                                    <th>Active</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <p>The Bell is a clickable icon that appears on your website and allows readers to easily manage their subscription.</p>
                                    </td>
                                    {
                                        !isFeatureAvailable('bell-notification') ? <>
                                            <td>
                                                    Feature available for Premium/Enterprise users
                                                    
                                            </td>
                                            <td>
                                            <PremiumLock />
                                            </td>
                                        </>
                                        : <>
                                            <td>
                                                <label className="toggle-control toggle-control-sm ">
                                                    <input type="checkbox" checked={bell_prompt} onChange={handelBellPromptChange}  />
                                                    <span className="control"></span>
                                                </label>
                                            </td>
                                            <td><button className="btn btn-primary" onClick={() => history.push('/bell-prompt')}  >Setup</button></td>
                                        </>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>                           
                    <div className="table-responsive my-3">
                        <table className="table table-hover permissions-table">
                            <colgroup>
                                <col width="45%"/>
                                <col width="10%"/>
                                <col width="12%"/>
                            </colgroup>
                            <thead className="bg-grey">                                        
                                <tr>
                                    <th>Hide Branding</th>
                                    <th></th>
                                    <th>Active</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <p>Hide the ChirpyWeb  branding from all permission prompts!</p>
                                    </td>
                                    <td>

                                    </td>
                                    {
                                        !isFeatureAvailable('hide-branding') ? <>
                                            <td>
                                                <PremiumLock />
                                            </td> 
                                        </>
                                        : <>
                                            <td>
                                                <label className="toggle-control toggle-control-sm ">
                                                    <input type="checkbox" checked={!selectedWebsite?.is_branding_enabled} onChange={updateBrandingForPrompt.mutate}  />
                                                    <span className="control"></span>
                                                </label>
                                            </td>
                                        </>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>                           

                </div>
        </div>
    </>
}

export default PermissionPrompt;